import { render, staticRenderFns } from "./modifyGameOrder.vue?vue&type=template&id=409473da&scoped=true&"
import script from "./modifyGameOrder.vue?vue&type=script&lang=js&"
export * from "./modifyGameOrder.vue?vue&type=script&lang=js&"
import style0 from "./modifyGameOrder.vue?vue&type=style&index=0&id=409473da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409473da",
  null
  
)

export default component.exports